import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

type TripStatus = 'scheduled' | 'in_progress' | 'completed' | 'cancelled';

interface FieldTripFilters {
  status?: TripStatus | TripStatus[];
}

export function useFieldTrips(filters?: FieldTripFilters) {
  return useQuery({
    queryKey: ['admin-field-trips', filters],
    queryFn: async () => {
      let query = supabase
        .from('field_trips')
        .select(`
          *,
          customer:customers(id, name),
          location:locations(id, name),
          lead_technician:users!field_trips_lead_technician_id_fkey(id, full_name, email)
        `)
        .order('start_date', { ascending: false });

      if (filters?.status) {
        if (Array.isArray(filters.status)) {
          query = query.in('status', filters.status);
        } else {
          query = query.eq('status', filters.status);
        }
      }

      const { data, error } = await query;
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 2 * 60 * 1000,
  });
}
